module.exports = __webpack_public_path__ + "static/media/tumblr.5bfa4257.svg";